
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface ChapterErrorProps {
  error: string | null;
}

const ChapterError: React.FC<ChapterErrorProps> = ({ error }) => {
  const navigate = useNavigate();
  
  return (
    <div className="pulse-container min-h-[var(--app-height)] overflow-y-auto p-4">
      <div className="rounded-lg bg-red-50 text-red-600 p-4">
        <h2 className="font-bold text-lg mb-2">Erro</h2>
        <p>{error}</p>
        <button 
          onClick={() => navigate(-1)} 
          className="mt-4 px-4 py-2 bg-primary-900 text-white rounded-lg"
        >
          Voltar
        </button>
      </div>
    </div>
  );
};

export default ChapterError;
